export default {
  items: [
    {
      title: true,
      name: 'Info',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    // {
    //   name: 'Service',
    //   url: '/service',
    //   icon: 'fa fa-inbox',
    //   children: [
    //     {
    //       name: 'Inquiry',
    //       url: '/service/inquiry',
    //       icon: 'fa fa-question'
    //     },
    //     {
    //       name: 'Service Request',
    //       url: '/service/request',
    //       icon: 'icon-envelope'
    //     }
    //   ]
    // },
    {
      name: 'Search History',
      url: '/search-history',
      icon: 'fa fa-history',
      children: [
        {
          name: 'List',
          url: '/search-history/list',
          icon: 'fa fa-search'
        }, {
          name: 'By User',
          url: '/search-history/user',
          icon: 'fa fa-info'
        }
      ]
    },
    {
      title: true,
      name: 'Management',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    }, {
      name: 'Master Data',
      icon: 'fa fa-users',
      class: 'restricted',
      children: [
        {
          name: 'Four Wheel',
          url: '/io/import',
          icon: 'fa fa-upload',
          class: 'restricted',
        }, {
          name: 'Two Wheel',
          url: '/io/import-twowheel',
          icon: 'fa fa-upload',
          class: 'restricted',
        },
      ]
    }, {
      name: 'Account',
      url: '/account',
      icon: 'fa fa-users',
      children: [
        {
          name: 'User',
          url: '/account/user',
          icon: 'fa fa-users'
        }, {
          name: 'Admin',
          url: '/account/admin',
          icon: 'fa fa-key restricted-icon'
        }, {
          name: 'Officer',
          url: '/account/officer',
          icon: 'fa fa-briefcase restricted-icon'
        }
      ]
    },
    {
      name: 'Office',
      url: '/office',
      icon: 'fa fa-briefcase',
      children: [
        {
          name: 'Inquiry',
          url: '/office/inquiry',
          icon: 'fa fa-question',
          class: 'restricted',
        }, {
          name: 'Countries',
          url: '/office/country',
          icon: 'fa fa-globe restricted-icon'
        }, {
          name: 'Offices',
          url: '/office/offices',
          icon: 'fa fa-building'
        }, {
          name: 'Privacy Policies',
          url: '/office/privacy-policy',
          icon: 'fa fa-file-text'
        }, {
          name: 'Banners',
          url: '/office/banner',
          icon: 'fa fa-image'
        }, {
          name: 'News',
          url: '/office/news',
          icon: 'fa fa-newspaper-o'
        }
      ]
    }, 
    {
      name: 'Forum',
      icon: 'fa fa-newspaper-o',
      children: [
        {
          name: 'Categories',
          url: '/office/forum/category',
          icon: 'fa fa-newspaper-o'
        },
        {
          name: 'Subcategories',
          url: '/office/forum/subcategory',
          icon: 'fa fa-newspaper-o'
        },
        {
          name: 'Post',
          url: '/office/forum/posts',
          icon: 'fa fa-newspaper-o'
        },
        {
          name: 'Tnc',
          url: '/office/forum/tnc',
          icon: 'fa fa-file-text'
        },
        {
          name: 'Access Config',
          url: '/office/forum/config',
          icon: 'fa fa-gear'
        },
        {
          name: 'Report',
          icon: 'fa fa-history',
          children: [
            {
              name: 'Category Post Comment',
              url: '/office/forum/report/category-post-comment',
              icon: 'fa fa-history'
            },
            {
              name: 'Product Mention',
              url: '/office/forum/report/product-mention',
              icon: 'fa fa-history'
            },
            {
              name: 'Most Engaged',
              url: '/office/forum/report/most-engaged',
              icon: 'fa fa-history'
            },
            {
              name: 'Contact Request',
              url: '/office/forum/report/contact-request',
              icon: 'fa fa-history'
            },
          ]
        }
      ]
    }, {
      name: 'Content',
      url: '/content',
      icon: 'fa fa-pencil restricted-icon',
      class: 'restricted',
      children: [
        {
          name: 'Slide',
          url: '/content/slide',
          icon: 'fa fa-newspaper-o'
        }, {
          name: 'Pages',
          url: '/content/page',
          icon: 'fa fa-file-text'
        }, {
          name: 'News Category',
          url: '/content/news-category',
          icon: 'fa fa-object-group'
        }, {
          name: 'FAQ',
          url: '/content/faq',
          icon: 'fa fa-question'
        }, {
          name: 'Fault Finding',
          url: '/content/fault-finding',
          icon: 'fa fa-newspaper-o'
        }, {
          name: 'Fault Finding Category',
          url: '/content/fault-finding-category',
          icon: 'fa fa-object-group'
        }
      ]
    }, {
      title: true,
      name: 'Others',
      class: 'restricted',
      wrapper: {
        element: '',
        attributes: {}
      }
    }, {
      name: 'Configuration',
      url: '/config',
      icon: 'fa fa-gear',
      class: 'restricted',
    }
  ]
}
